import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PrimeNGModule} from '../../core';

import {AdminComponent} from './admin.component';

import {CustomerModule} from '../customer/customer.module';
import {UserModule} from '../user/user.module';
import {UserGroupModule} from '../user-group/user-group.module';
import {ConfigurationModule} from '../configuration/configuration.module';
import {NotificationsModule} from './notifications/notifications.module';
import {AdminRoutingModule} from './admin-routing.module';

@NgModule({
  imports: [
    CommonModule, AdminRoutingModule, PrimeNGModule,
    CustomerModule, UserModule, ConfigurationModule, NotificationsModule, UserGroupModule
  ],
  declarations: [AdminComponent]
})
export class AdminModule {
}
